import React from 'react';
import { BadgeIntent, LiteralUnion } from '../common/props';
import {
  ColorDef,
  colorsMapBadge,
  ColorType,
  getContrastYIQColor,
  pSBC,
} from '../common/colors';
import classNames from 'classnames';
import * as Classes from '../common/classes';
import { InverseBgProvider } from '../theme/InverseBg';
type Props = {
  intent?: BadgeIntent;
  color?: LiteralUnion<ColorType, string>;
  className?: string;
};
export const Badge: React.FC<Props> = ({
  intent,
  color,
  children,
  className,
}) => {
  let colorStyle;
  if (color) {
    let colorVal: ColorDef = colorsMapBadge[color] || {
      bg: color,
      text: getContrastYIQColor(color),
      border: pSBC(-0.29, color),
    };

    colorStyle = {
      backgroundColor: colorVal.bg,
      color: colorVal.text,
      outlineColor: colorVal.border,
    };
  } else {
    colorStyle = {};
  }
  let cls = classNames(Classes.BADGE, className, {
    [color?.startsWith('#')
      ? Classes.BADGE_COLOR + color?.substring(1)
      : Classes.BADGE_COLOR + color]: color,
    [Classes.BADGE_DEFAULT]: !intent || intent === 'default',
    [Classes.BADGE_PRIMARY]: intent === 'primary',
    [Classes.BADGE_DANGER]: intent === 'danger',
    [Classes.BADGE_SUCCESS]: intent === 'success',
    [Classes.BADGE_WARNING]: intent === 'warning',
    [Classes.BADGE_INACTIVE]: intent === 'inactive',
    [Classes.BADGE_SECONDARY]: intent === 'secondary',
  });
  const isInverse = (!!intent && intent !== 'default') || (!intent && !!color);
  return (
    <div style={colorStyle} className={cls}>
      <InverseBgProvider inverse={isInverse}>{children}</InverseBgProvider>
    </div>
  );
};
